import { Button, Dropdown, Input } from "@oc-labs/wt-storybook";
import useMethodSystem from "../useMethodSystem";
import Toggle from "../../Toggle";
import TransactionsConfig from "./TransactionsConfig";

export default function CheckoutType() {
  const { back, contracts, contract, setContract, requiresKyc, allowedContracts, 
    setAllowedContracts, setRequiresKyc, transactions, monthlyLimit, setMonthlyLimit, 
    createMethod, isEditing, setMinAmount, minAmount
  } = useMethodSystem();


  const contractFromSameNetwork = contracts.filter(c => {
    return contract ? c.networkId === contract.networkId : true;
  }).filter(c => c.id !== contract?.id);

  console.log("contractFromSameNetwork", contractFromSameNetwork);

  return (<div className="h-full flex flex-col">
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-bold">Create Checkout Method</h2>
        <div>   
        <Button type="secondary" size="small" onClick={back}>
          Back
        </Button>
        </div>
      </div>

    <div className="grid grid-cols-2 gap-4 items-center">
      <Dropdown 
        label="Contract"  
        options={contracts.sort((a, b) => a?.network?.chainId - b?.network?.chainId).map(contract => ({
          value: contract.id,
          label: `${contract.name} - ${contract?.network?.name}`
        }))}
        value={contract ? contract.id : ""}
        onChange={(selected) => {
          const selectedContract = contracts.find(c => c.id === selected);
          if (selectedContract?.networkId !== contract?.networkId) {
            setRequiresKyc(false);
            setAllowedContracts([]);
          }
          setContract(selectedContract);
          
        }}
      />
      <div className="flex gap-4 my-4 justify-center items-center">
        <p className="font-medium">KYC Requirement</p>
        <Toggle
          text="Require KYC"
          onChange={() => setRequiresKyc(!requiresKyc)}
          checked={requiresKyc}
        />
      </div>
    </div>
    <Input
      placeholder="Monthly Limit, e.g. 1000, 5000"
      value={monthlyLimit}
      onChange={(e) => setMonthlyLimit(Number(e.target.value) || 0)}
      label="Monthly Limit"
      type="number"
    />
    <Input
      placeholder="Minimum Amount Per Transaction, e.g. 10, 50"
      value={minAmount}
      onChange={(e) => setMinAmount(Number(e.target.value) || 0)}
      label="Minimum Amount Per Transaction"
      type="number"
    />
    {contracts?.length > 0 ? (contract ? <div>
    <p className="mt-4 text-[12px]">Select Additional Contracts from the Same Network</p>
      <div className="space-y-2 max-h-64 overflow-y-auto mt-4">
        {contractFromSameNetwork.sort((a, b) => a?.network?.chainId - b?.network?.chainId).map((contractOption) => {
            return (
              <label
                key={contractOption.id}
                className={`flex items-center gap-3 px-3 rounded-md cursor-pointer transition-colors bg-gray-50 hover:bg-gray-100 border-2 border-transparent`}
              >
                <input
                  checked={allowedContracts.some(c => c === contractOption.id)}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setAllowedContracts([...allowedContracts, contractOption.id]);
                    } else {
                      setAllowedContracts(allowedContracts.filter(c => c !== contractOption.id));
                    }
                  }}
                  type="checkbox"
                  className="w-4 h-4 text-blue-600 rounded focus:ring-2 focus:ring-blue-500"
                />
                <div className="flex-1">
                  <p className="font-medium">{contractOption.name}</p>
                  <p className="text-sm text-gray-600">{contractOption?.network?.name} - {contractOption?.address}</p>
                </div>
              </label>
            )
          })}
      </div>
    </div> : <div>
    <p className="mt-4 text-[12px]">Select Additional Contracts from the Same Network</p>
      <div className="flex items-center gap-3 p-6 rounded-md transition-colors bg-gray-50 hover:bg-gray-100 border-2 border-transparent">
        Please select a contract first.
      </div>
    </div>) : (<div>
      <p className="mt-4 text-[12px]">There are no contracts available on this network to be used as checkout. Please create a contract first.</p>
    </div>)}

    <TransactionsConfig />
    
    <Button 
      disabled={!contract || contracts?.length === 0 || !contracts?.length}
      type="primary" 
      className="mt-auto"
      onClick={() => {
      createMethod({
        contractId: contract.id,
        requiresKyc,
        dailyLimit: monthlyLimit,
        monthlyLimit,
        minAmount,
        maxAmount: 0,
        allowedContractIds: allowedContracts,
        transactions
      });
    }}>
      {isEditing ? 'Update' : 'Create'}
    </Button>
  </div>);
}